import styled from 'styled-components';
import Coding from '@assets/images/content/roles/coding.svg'; 
import Consulting from '@assets/images/content/roles/consulting.svg'; 
import Design from '@assets/images/content/roles/design.svg'; 
import Profreading from '@assets/images/content/roles/open-book.svg'; 
import Seo from '@assets/images/content/roles/seo.svg'; 
import Writing from '@assets/images/content/roles/writing.svg'; 

export const CodingImg = styled(Coding)`
`;

export const ConsultingImg = styled(Consulting)`
`;

export const DesignImg = styled(Design)`
`;

export const ProfreadingImg = styled(Profreading)`
`;

export const SeoImg = styled(Seo)`
`;

export const WritingImg = styled(Writing)`
`;
